
export class AppChartsService {


  constructor(

  ) {}

  // 初始化图表
  chartsInit(options, target){
    let charts = echarts.init(target);
    charts.setOption(options);
  }



  //设置图表属性
  setChartsAttribute(theme, type, data, max){
    let opts= {},
      objKey = {"radar": "radar"}[type]|| "radar",
      indicatorList = this.formatChartsData(data, "kaName"),
      valueList = this.formatChartsData(data, "kaScore");

    opts[objKey] = theme.base;
    opts[objKey]["indicator"] = this.setChartsAttributeIndicator(theme.indicatorAxisLabel, indicatorList, max);
    opts["series"] = this.setChartsSeries(theme.series , type , valueList);
    return opts;
  }

  //设置Indicator
  setChartsAttributeIndicator(indicatorOpts, dataList, max){
    let indicator = [];
    for(let i = 0, len = dataList.length; i<len; i+=1){
      indicator[i] = {
        "name": dataList[i],
        "max": max
      };

      if(i==0){
        indicator[i].axisLabel = indicatorOpts;
      }
    }
    return indicator;
  }

  // 设置图表Series
  setChartsSeries(seriesOpts, type, dataList){
	  let series ={};
	  series["type"] = type;
	  series["symbol"] = seriesOpts.symbol ;
    series["data"] =this.setChartsSeriesData(seriesOpts, dataList);
	  return series;
  }

  //设置Series的data
  setChartsSeriesData(seriesOpts, dataList){
    let data = [];
    for(let i = 0, len =dataList.length; i<len;i+=1 ){
      data[i]={};
      data[i]['itemStyle'] = {};
      data[i]['itemStyle']['normal'] = {};
      data[i]['value'] = dataList[i];
      data[i]['itemStyle']['normal'] = seriesOpts.seriesDataStyle[i];
    }
    return data;
  }

  // 格式化数据
  formatChartsData(data, keyName){
    let arr  = [];
    if(keyName!=="kaScore"){
      data[0].forEach(v=>{
        arr.push(v[keyName]);
      });
    }else{
      for(let i = 0, len =data.length; i<len; i+=1 ){
        arr[i] = [];
       data[i].forEach(v=>{
          arr[i].push(v[keyName]);
       });
      }
    }
    return arr;
  }

}







// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.service.ts